import { ClientFormData } from '@/types/clients/ClientFormData';
import { Control } from 'react-hook-form';
import HorizontalLine from '@/components/ui/HorizontalLine';
import StyledFormSection from '@/components/styled/StyledFormSection';
import StyledInput from '@/components/styled/StyledInput';
import MarginRateStyledInput from '@/components/styled/MarginRateStyledInput';
import StyledSelect from '@/components/styled/StyledSelect';
import { LabelValue } from '@/types/global';
import { useTranslation } from '@/i18n';

interface ClientFormProps {
  control: Control<ClientFormData>;
  agents?: LabelValue<string>[];
  isAdmin?: boolean;
  isViewMode?: boolean;
  isTourOperator?: boolean;
}

const ClientForm = ({
  control,
  agents = [],
  isAdmin = false,
  isViewMode = false,
  isTourOperator = false,
}: ClientFormProps) => {
  const { t } = useTranslation();
  const formNs = isTourOperator ? 'distributorAgencies.form' : 'clients.form';

  return (
    <>
      <StyledFormSection sectionTitle="Informations administratives">
        {isTourOperator && (
          <StyledInput
            control={control}
            name="agencyName"
            title={`${t(`${formNs}.agencyName`)} *`}
            disabled={isViewMode}
          />
        )}
        <h2 className="text-base font-medium text-black">
          {t(`${formNs}.mainContact`)}
        </h2>
        <div className="flex flex-col md:flex-row gap-4">
          <StyledInput
            control={control}
            name="mainContact.lastName"
            title={`${t(`${formNs}.lastName`)} *`}
            disabled={isViewMode}
          />
          <StyledInput
            control={control}
            name="mainContact.firstName"
            title={`${t(`${formNs}.firstName`)} *`}
            disabled={isViewMode}
          />
        </div>
        {isTourOperator && (
          <StyledInput
            control={control}
            name="mainContact.email"
            title={`${t(`${formNs}.email`)} *`}
            type="email"
            disabled={isViewMode}
          />
        )}
        {/* <div className="flex flex-col md:flex-row gap-4">
          <StyledInput
            control={control}
            name="mainContact.email"
            title={t('clients.form.email')}
            disabled={isViewMode}
          />
          <StyledInput
            control={control}
            name="mainContact.phoneNumber"
            title={t('clients.form.phoneNumber')}
            type="tel"
            disabled={isViewMode}
          />
        </div>
        <ClientContacts control={control} isViewMode={isViewMode} />
        <StyledInput
          control={control}
          name="address"
          title={t('clients.form.address')}
          disabled={isViewMode}
        />
        <div className="flex flex-col md:flex-row gap-4">
          <StyledInput
            control={control}
            name="postalCode"
            title={t('clients.form.postalCode')}
            type="number"
            hideNumberFieldArrows
            disabled={isViewMode}
          />
          <StyledInput
            control={control}
            name="city"
            title={t('clients.form.city')}
            disabled={isViewMode}
          />
        </div>
        <div className="w-1/2 pr-2">
          <StyledSelect
            options={COUNTRIES}
            control={control}
            name="country"
            title={t('clients.form.country')}
            placeholder=""
            disabled={isViewMode}
          />
        </div> */}
      </StyledFormSection>
      <HorizontalLine />
      <StyledFormSection sectionTitle={t('clients.form.additionalInfo')}>
        <div className="flex flex-col md:flex-row gap-4 items-end">
          <MarginRateStyledInput
            control={control}
            name="marginRate"
            title={t('clients.form.marginRate')}
            disabled={isViewMode}
          />
          <StyledSelect
            options={agents}
            control={control}
            name="reservationAgent"
            title={t('clients.form.reservationAgent')}
            placeholder=""
            disabled={isViewMode || !isAdmin}
          />
        </div>
      </StyledFormSection>
    </>
  );
};

export default ClientForm;
